const RadioCheckboxInput = ({
  id,
  label,
  name,
  value,
  checked,
  onChange,
  type = "radio",
}: {
  id: string;
  label: string;
  name: string;
  value: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: "radio" | "checkbox";
}) => {
  return (
    <>
      <div
        key={id}
        className="single-checked-input d-flex align-items-center gap-1"
      >
        <label htmlFor={id} className="pe-2">
          {label}
        </label>
        <input
          type={type}
          name={name}
          id={id}
          value={value}
          checked={checked}
          onChange={onChange}
        />
      </div>
    </>
  );
};

export default RadioCheckboxInput;
